require('./focusIf');
module.exports = 'focus-if';
